<template>
  <div id="footer" class="footer relative">
    <div class="footer__top">
      <div class="footer__top-logo">
        <img
          class="sanofi-logo-footer"
          :src="require('@/assets/img/sanofi_footer_2025.png')"
        />
      </div>
      <div class="footer__top-socmed">
        <!-- <socmed-section /> -->
      </div>
    </div>
    <div class="footer__bottom">
      <div class="footer__content-container">
        <div class="footer__bottom-sitemap">
          Contact: <br />
          Phone: +41 058 440 21 00 <br />
          Email:
          <a href="mailto:contact.ch@sanofi.com" target="_blank"
            >contact.ch@sanofi.com</a
          >
          <br />
          <a href="https://www.sanofi.ch/de/mentions-legales" target="_blank">
            Legal mention
          </a>
          <div class="mt-2">
            <a
              class="anchor-link"
              href="https://www.sanofi.ch/de/protection-des-donn%C3%A9es/SACH"
              target="_blank"
            >
              Datenschutz
            </a>
            <br />
            <a
              class="anchor-link"
              href="https://www.sanofi.ch/fr/protection-des-donn%C3%A9es/SACH"
              target="_blank"
            >
              Protection des données
            </a>
          </div>
        </div>
        <div class="mt-2">
          <a
            class="anchor-link"
            href="https://www.sanofi.ch/de/protection-des-donn%C3%A9es/SACH"
            target="_blank"
          >
            Datenschutz
          </a>
          <br />
          <a
            class="anchor-link"
            href="https://www.sanofi.ch/fr/protection-des-donn%C3%A9es/SACH"
            target="_blank"
          >
            Protection des données
          </a>
        </div>
        <div class="footer__bottom-text">
          <span v-html="footerText"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import SocmedSection from "./SocialMedia.vue";

export default {
  name: "PompeFooter",
  computed: {
    footerText() {
      return `Website for pompe disease treaters in Switzerland <br />
      &copy;${new Date().getFullYear()} sanofi-aventis (schweiz) ag. All rights reserved. <br />
      Approval Nr: MAT-CH-2200959-v2.0-01/2025
      `;
    },
    isForm() {
      return (
        this.$route.path.includes("add-new-patient") ||
        this.$route.path.includes("assessment-data") ||
        this.$route.path.includes("profile") ||
        this.$route.path.includes("create") ||
        this.$route.path.includes("edit") ||
        this.$route.path.includes("overview") ||
        this.$route.path.includes("summary") ||
        this.$route.path.includes("login") ||
        this.$route.path.includes("information") ||
        this.$route.path.includes("documents") ||
        this.$route.path.includes("evaluation") ||
        this.$route.path.includes("password")
      );
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/style/color.scss";
@import "@/style/responsive.scss";

.footer {
  width: 100%;
  bottom: 0;

  @include mediumInBetween {
    position: fixed;
  }

  &.relative {
    position: relative;
  }

  &.fixed {
    position: fixed;
    margin-top: 100px;
  }

  &.absolute {
    position: absolute;
    bottom: 0;
  }

  &__top {
    background-color: #000;
    height: 10em;
    display: flex;
    justify-content: center;
    align-items: center;

    &-logo {
      width: 1100px;
    }

    .sanofi-logo-footer {
      width: 250px;
    }
  }

  &__bottom {
    font-size: 13px;
    background-color: $footer-bottom;
    display: flex;
    justify-content: center;
    padding-bottom: 15px;

    .footer__content-container {
      width: 1100px;
      display: flex;
      justify-content: space-between;
      padding-top: 1em;
    }

    &-sitemap {
      a {
        color: $footer-bottom-text;
      }

      width: 30%;
      text-align: left;
      padding-top: 1em;
    }

    &-text {
      width: 30%;
      text-align: left;
      padding: 1em;
      color: $footer-bottom-text;
    }
  }
}
</style>
